import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRightFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutRightFull"><Path d="M20.5 3.5L21 3.5V3L20.5 3V3.5ZM3.5 3.5L3.5 3L3 3L3 3.5L3.5 3.5ZM3.5 20.5H3L3 21H3.5L3.5 20.5ZM20.5 20.5V21H21V20.5H20.5ZM20.5 3L3.5 3L3.5 4L20.5 4V3ZM3 3.5L3 20.5H4L4 3.5L3 3.5ZM3.5 21L20.5 21V20L3.5 20L3.5 21ZM21 20.5L21 3.5L20 3.5L20 20.5H21Z" fill="currentColor"/><Path d="M14 20.5L14 21H15L15 20.5H14ZM15 3.5L15 3L14 3L14 3.5L15 3.5ZM15 20.5L15 3.5L14 3.5L14 20.5H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutRightFull;
